import { Button } from "@src/components/ui/button";
import { cn } from "@lib/utils/ui";
type AuthButtonProps = {
  isPending: boolean;
  text: string;
  pendingText: string;
  className?: string;
};
export function AuthButton({
  isPending,
  text,
  pendingText,
  className
}: AuthButtonProps) {
  return <Button type="submit" className={cn("w-full", className)} disabled={isPending} data-sentry-element="Button" data-sentry-component="AuthButton" data-sentry-source-file="AuthButton.tsx">
      {isPending ? pendingText : text}
    </Button>;
}